import BaseApi from './BaseApi'

class AccessControlApi extends BaseApi {
  constructor() {
    super('access-control')
  }

  async getMyPermissions() {
    const api = this.getApiInstance(true)
    const response = await api.get(`/${this.endpoint}/me`)
    return response.data
  }

  async getMyRoles() {
    const api = this.getApiInstance(true)
    const response = await api.get(`/${this.endpoint}/me/roles`)
    return response.data
  }

  async checkPermission(code) {
    const api = this.getApiInstance(true)
    const response = await api.get(`/${this.endpoint}/check`, { params: { code } })
    return response.data
  }

  async checkPathAccess(path) {
    const api = this.getApiInstance(true)
    const response = await api.get(`/${this.endpoint}/check-path`, { params: { path } })
    return response.data
  }

  async getInterfaces() {
    const api = this.getApiInstance(true)
    const response = await api.get(`/${this.endpoint}/interfaces`)
    return response.data
  }

  async getUsers() {
    const api = this.getApiInstance(true)
    const response = await api.get(`/${this.endpoint}/users`)
    return response.data
  }

  async getUserPermissions(userId) {
    const api = this.getApiInstance(true)
    const response = await api.get(`/${this.endpoint}/users/${userId}`)
    return response.data
  }

  async updateUserPermissions(userId, permissions) {
    const api = this.getApiInstance(true)
    const response = await api.put(`/${this.endpoint}/users/${userId}`, { permissions })
    return response.data
  }

  async bulkUpdateUserPermissions(userIds, permissions) {
    const api = this.getApiInstance(true)
    const response = await api.put(`/${this.endpoint}/users/bulk`, { userIds, permissions })
    return response.data
  }

  async getRoles() {
    const api = this.getApiInstance(true)
    const response = await api.get(`/${this.endpoint}/roles`)
    return response.data
  }

  async getRole(roleId) {
    const api = this.getApiInstance(true)
    const response = await api.get(`/${this.endpoint}/roles/${roleId}`)
    return response.data
  }

  async createRole(payload) {
    const api = this.getApiInstance(true)
    const response = await api.post(`/${this.endpoint}/roles`, payload)
    return response.data
  }

  async updateRole(roleId, payload) {
    const api = this.getApiInstance(true)
    const response = await api.put(`/${this.endpoint}/roles/${roleId}`, payload)
    return response.data
  }

  async deleteRole(roleId) {
    const api = this.getApiInstance(true)
    const response = await api.delete(`/${this.endpoint}/roles/${roleId}`)
    return response.data
  }

  async assignRoleUsers(roleId, userIds) {
    const api = this.getApiInstance(true)
    const response = await api.put(`/${this.endpoint}/roles/${roleId}/users`, { userIds })
    return response.data
  }

  async getUserRoles(userId) {
    const api = this.getApiInstance(true)
    const response = await api.get(`/${this.endpoint}/user-roles/${userId}`)
    return response.data
  }

  async setUserRoles(userId, roleIds) {
    const api = this.getApiInstance(true)
    const response = await api.put(`/${this.endpoint}/user-roles/${userId}`, { roleIds })
    return response.data
  }
}

export default new AccessControlApi()
